// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal overlay */
.modal-overlay1 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

/* Modal content */
.modal-content1 {
    overflow: auto;
    background-color: white;
    padding: 25px;
    width: 500px; /* Increased width of the modal */
    height:500px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    position: relative;
}
.modal-content2 {
    overflow: auto;
    background-color: white;
    padding: 25px;
    width: 800px; /* Increased width of the modal */
    height:500px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    position: relative;
}

/* Close button */
.close-button1 {
    position: absolute;
    top: 0px;
    right: 0px;
    background: transparent;
    border: none;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.3s ease; /* Optional for smooth transition */
}

.close-button1:hover {
    color: #007BFF; /* Change text color on hover */
    transform: scale(1.1); /* Slightly enlarge the button */
}
/* Title Styling */
.modal-title1 {
    background-color: #007BFF; /* Blue background color */
    color: white; /* White text color */
    padding: 10px 20px; /* Padding inside the heading */
    font-size: 18px; /* Adjust the font size */
    font-weight: bold; /* Optional: bold text */
    border-radius: 5px; /* Optional: rounded corners */
    text-align: center; /* Optional: center-align text */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
    margin-bottom: 20px;
}
.modal-title-ftl {
    color: black; /* White text color */
    padding: 10px 20px; /* Padding inside the heading */
    font-size: 18px; /* Adjust the font size */
    font-weight: bold; /* Optional: bold text */
    border-radius: 5px; /* Optional: rounded corners */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
    margin-bottom: 20px;
}

/* Timeline Container */
.timeline-container1 {
    display: flex;
    /* justify-content: center; */
    padding: 20px 0;
}

/* Vertical stripe for timeline */
.timeline-stripe1 {
    position: relative;
    width: 12px; /* Adjusted width for stripe */
    background-color: #1e90ff; /* Blue stripe color */
    margin: 0 30px;
}

/* Timeline Event Styles */
.timeline-event1 {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
}

/* Blue Dot (for non-final events) */
.timeline-dot1 {
    height: 9px;
    width: 9px;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 50%;
    transform: translateY(-50%);
}

/* Green Dot (for final event) */
.timeline-dot1.green-dot1 {
    background-color: #4caf50; /* Green for the last event */
}
.timeline-dot1.truck-image1 {
    background-color: transparent; /* No background color for the truck image */
    width: 35px; /* Adjust the size of the truck image */
    height: 35px;
    top: 50%;
    left: -8px; /* Adjust the image's position */
    transform: translateY(-50%);
}


/* Blue Dot (for all other events) */
.timeline-dot1.blue-dot1 {
    background-color: #bcf1f7; /* Blue for other events */
}

/* Timeline Content */
.timeline-content1 {
    margin-left: 30px;
    padding: 10px;
    width:400px;
    background: #f0f0f0;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.timeline-content1 p {
    margin: 5px 0;
    font-size: 14px;
    width:300px;

}
.timeline-dot1 img.truck-icon1 {
    border-radius: 50%;  /* Make the truck image circular */
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2); /* Shadow effect for truck image */
}
.truck-image-icon1 {
    width: 100%;
    height: 100%;
    object-fit: contain; /* Ensure the truck image is contained within the dot's size */
    border-radius: 50%; /* Optional: if you want the image inside a circle */
    box-shadow: 0 0 10px rgba(30, 144, 255, 0.8); /* Glowing blue shadow */
    transition: box-shadow 0.3s ease-in-out; /* Smooth transition for hover effect */
}

.truck-image-icon1:hover {
    box-shadow: 0 0 20px rgba(30, 144, 255, 1); /* Stronger glow on hover */
}`, "",{"version":3,"sources":["webpack://./src/components/tracktrace/timelinestyles.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,kBAAkB;AAClB;IACI,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,YAAY,EAAE,iCAAiC;IAC/C,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,YAAY,EAAE,iCAAiC;IAC/C,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,yBAAyB,EAAE,mCAAmC;AAClE;;AAEA;IACI,cAAc,EAAE,+BAA+B;IAC/C,qBAAqB,EAAE,gCAAgC;AAC3D;AACA,kBAAkB;AAClB;IACI,yBAAyB,EAAE,0BAA0B;IACrD,YAAY,EAAE,qBAAqB;IACnC,kBAAkB,EAAE,+BAA+B;IACnD,eAAe,EAAE,yBAAyB;IAC1C,iBAAiB,EAAE,wBAAwB;IAC3C,kBAAkB,EAAE,8BAA8B;IAClD,kBAAkB,EAAE,gCAAgC;IACpD,wCAAwC;IACxC,mBAAmB;AACvB;AACA;IACI,YAAY,EAAE,qBAAqB;IACnC,kBAAkB,EAAE,+BAA+B;IACnD,eAAe,EAAE,yBAAyB;IAC1C,iBAAiB,EAAE,wBAAwB;IAC3C,kBAAkB,EAAE,8BAA8B;IAClD,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,WAAW,EAAE,8BAA8B;IAC3C,yBAAyB,EAAE,sBAAsB;IACjD,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;AAC/B;;AAEA,gCAAgC;AAChC;IACI,yBAAyB,EAAE,6BAA6B;AAC5D;AACA;IACI,6BAA6B,EAAE,4CAA4C;IAC3E,WAAW,EAAE,uCAAuC;IACpD,YAAY;IACZ,QAAQ;IACR,UAAU,EAAE,gCAAgC;IAC5C,2BAA2B;AAC/B;;;AAGA,oCAAoC;AACpC;IACI,yBAAyB,EAAE,0BAA0B;AACzD;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;;AAEf;AACA;IACI,kBAAkB,GAAG,kCAAkC;IACvD,sCAAsC,EAAE,kCAAkC;AAC9E;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAE,8DAA8D;IACnF,kBAAkB,EAAE,oDAAoD;IACxE,4CAA4C,EAAE,wBAAwB;IACtE,uCAAuC,EAAE,uCAAuC;AACpF;;AAEA;IACI,0CAA0C,EAAE,2BAA2B;AAC3E","sourcesContent":["/* Modal overlay */\n.modal-overlay1 {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n/* Modal content */\n.modal-content1 {\n    overflow: auto;\n    background-color: white;\n    padding: 25px;\n    width: 500px; /* Increased width of the modal */\n    height:500px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    position: relative;\n}\n.modal-content2 {\n    overflow: auto;\n    background-color: white;\n    padding: 25px;\n    width: 800px; /* Increased width of the modal */\n    height:500px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    position: relative;\n}\n\n/* Close button */\n.close-button1 {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    background: transparent;\n    border: none;\n    font-size: 15px;\n    cursor: pointer;\n    transition: all 0.3s ease; /* Optional for smooth transition */\n}\n\n.close-button1:hover {\n    color: #007BFF; /* Change text color on hover */\n    transform: scale(1.1); /* Slightly enlarge the button */\n}\n/* Title Styling */\n.modal-title1 {\n    background-color: #007BFF; /* Blue background color */\n    color: white; /* White text color */\n    padding: 10px 20px; /* Padding inside the heading */\n    font-size: 18px; /* Adjust the font size */\n    font-weight: bold; /* Optional: bold text */\n    border-radius: 5px; /* Optional: rounded corners */\n    text-align: center; /* Optional: center-align text */\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); \n    margin-bottom: 20px;\n}\n.modal-title-ftl {\n    color: black; /* White text color */\n    padding: 10px 20px; /* Padding inside the heading */\n    font-size: 18px; /* Adjust the font size */\n    font-weight: bold; /* Optional: bold text */\n    border-radius: 5px; /* Optional: rounded corners */\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); \n    margin-bottom: 20px;\n}\n\n/* Timeline Container */\n.timeline-container1 {\n    display: flex;\n    /* justify-content: center; */\n    padding: 20px 0;\n}\n\n/* Vertical stripe for timeline */\n.timeline-stripe1 {\n    position: relative;\n    width: 12px; /* Adjusted width for stripe */\n    background-color: #1e90ff; /* Blue stripe color */\n    margin: 0 30px;\n}\n\n/* Timeline Event Styles */\n.timeline-event1 {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    position: relative;\n}\n\n/* Blue Dot (for non-final events) */\n.timeline-dot1 {\n    height: 9px;\n    width: 9px;\n    border-radius: 50%;\n    position: absolute;\n    left: 2px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n/* Green Dot (for final event) */\n.timeline-dot1.green-dot1 {\n    background-color: #4caf50; /* Green for the last event */\n}\n.timeline-dot1.truck-image1 {\n    background-color: transparent; /* No background color for the truck image */\n    width: 35px; /* Adjust the size of the truck image */\n    height: 35px;\n    top: 50%;\n    left: -8px; /* Adjust the image's position */\n    transform: translateY(-50%);\n}\n\n\n/* Blue Dot (for all other events) */\n.timeline-dot1.blue-dot1 {\n    background-color: #bcf1f7; /* Blue for other events */\n}\n\n/* Timeline Content */\n.timeline-content1 {\n    margin-left: 30px;\n    padding: 10px;\n    width:400px;\n    background: #f0f0f0;\n    border-radius: 5px;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n}\n\n.timeline-content1 p {\n    margin: 5px 0;\n    font-size: 14px;\n    width:300px;\n\n}\n.timeline-dot1 img.truck-icon1 {\n    border-radius: 50%;  /* Make the truck image circular */\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2); /* Shadow effect for truck image */\n}\n.truck-image-icon1 {\n    width: 100%;\n    height: 100%;\n    object-fit: contain; /* Ensure the truck image is contained within the dot's size */\n    border-radius: 50%; /* Optional: if you want the image inside a circle */\n    box-shadow: 0 0 10px rgba(30, 144, 255, 0.8); /* Glowing blue shadow */\n    transition: box-shadow 0.3s ease-in-out; /* Smooth transition for hover effect */\n}\n\n.truck-image-icon1:hover {\n    box-shadow: 0 0 20px rgba(30, 144, 255, 1); /* Stronger glow on hover */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
